import { ApplicationRef } from '@angular/core';
import { StoreModule } from '@ngrx/store';
import { BaseSecurityPageModule } from 'SecuritiesApp/ts/apps/base-security-page/app.module';
import { HoldingsOverlapModule } from 'SecuritiesApp/ts/features/holdings-overlap/holdings-overlap.module';
import { TopBarNavComponent } from 'Angular/features/components/navigation/top-bar-nav/top-bar-nav.component';
import { SideMenuComponent } from 'Angular/features/components/side-menu/side-menu.component';
import { HoldingsOverlapComponent } from 'SecuritiesApp/ts/features/holdings-overlap/holdings-overlap.component';
import { SecurityHeaderControlComponent } from 'SecuritiesApp/ts/features/security-header-control/security-header-control.component';
import { getLogger } from 'Angular/state/logger';
import * as i0 from "@angular/core";
import * as i1 from "@ngrx/store";
export class CompanyFundsHoldingsOverlapModule {
    ngDoBootstrap(appRef) {
        appRef.bootstrap(TopBarNavComponent);
        appRef.bootstrap(SideMenuComponent);
        appRef.bootstrap(SecurityHeaderControlComponent);
        appRef.bootstrap(HoldingsOverlapComponent);
    }
}
CompanyFundsHoldingsOverlapModule.ɵfac = function CompanyFundsHoldingsOverlapModule_Factory(__ngFactoryType__) { return new (__ngFactoryType__ || CompanyFundsHoldingsOverlapModule)(); };
CompanyFundsHoldingsOverlapModule.ɵmod = /*@__PURE__*/ i0.ɵɵdefineNgModule({ type: CompanyFundsHoldingsOverlapModule });
CompanyFundsHoldingsOverlapModule.ɵinj = /*@__PURE__*/ i0.ɵɵdefineInjector({ imports: [BaseSecurityPageModule, HoldingsOverlapModule, StoreModule.forRoot({}, { metaReducers: getLogger() })] });
